import React, { useState } from "react";
import Message from "./message";

export const LdServices = () => {
  const data = {
    line: [
      {
        name: "CONTA DIGITAL",
        text: "Gerencie seu dinheiro com uma conta de pagamentos digital fácil e rápido!",
        image: "./img/conta-digital.webp",
      },
      {
        name: "API DE PIX",
        text: "Automatize seus pagamentos com a nossa API de pix segura e de fácil integração!",
        image: "./img/pix.webp",
      },
      {
        name: "API DE BOLEPIX",
        text: "Automatize seus boletos e venda mais, com a nossa API de boletos de fácil integração!",
        image: "./img/bolepix.webp",
      },
      {
        name: "LINK DE PAGAMENTO",
        text: "Envie aos seus clientes um link de pagamento e aumente as suas vendas!",
        image: "./img/link-pagamento.webp",
      },
      {
        name: "GATEWAY DE PAGAMENTOS",
        text: "Automatize seus pagamentos através de nosso sistema via API de pix.",
        image: "./img/gatway-pagamento.webp",
      },
      {
        name: "CHECKOUT",
        text: "Venda mais com um checkout rápido e seguro!",
        image: "./img/checkout.webp",
      },
    ],
    DigitalBankCard: {
      title:
        'CRIE SEU BANCO DIGITAL COM SUA <span class="highlight">MARCA</span> E TENHA + <span class="highlight">LUCRATIVIDADE</span>',
      subtitle:
        "Temos a solução de BANK AS A SERVICE mais completa do MERCADO e totalmente PERSONALIZADA com a SUA MARCA.",
      items: [
        {
          text: "Plataforma Inteligente WHITE LABEL pensada Especialmente para seu NEGÓCIO ser uma Solução Financeira FINTECH!",
        },
        {
          text: "Interface de BANKING para sua Empresa CRIAR e OFERECER Serviços Financeiros Inovadores de forma MODULAR E FLEXÍVEL e o melhor: USANDO SUA MARCA.",
        },
        {
          text: "TRANSFORME seus Clientes, Fornecedores, Prestadores de Serviços e Funcionários em CORRENTISTAS do seu BANCO DIGITAL!",
        },
      ],
    },
  };

  const [showModal, setShowModal] = useState(false);

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <section id="services" className="ld-services-section">
      <div className="container text-center">
        <h2 className="section-title">
          SOLUÇÕES PARA O <span className="highlight">SEU NEGÓCIO</span>
        </h2>

        <div className="services-grid">
          {data.line.map((item, index) => (
            <div className="service-card" key={`${item.name}-${index}`}>
              <div className="image-wrapper">
                <img
                  src={item.image}
                  alt={item.name}
                  className="service-banner"
                />
              </div>
              <div className="service-content">
                <h3>{item.name}</h3>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>

      </div>

      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            overflowY: "auto",
            padding: "2rem 0",
          }}
          onClick={() => setShowModal(false)}
        >
          <div
            style={{
              background: "white",
              padding: "2rem",
              borderRadius: "8px",
              height: "auto",
              maxHeight: "95vh",
              width: "auto",
              position: "relative",
              zIndex: 10000,
              overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                fontSize: "1.5rem",
                background: "none",
                border: "none",
                cursor: "pointer",
              }}
            >
              ×
            </button>

            <div>
              <Message closeModal={closeModal} />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default LdServices;
